import { css, cx } from "@emotion/css";
import { InfoCircleIcon } from "@octopusdeploy/design-system-icons";
import { borderRadius, fontSize, fontWeight, space, themeTokens } from "@octopusdeploy/design-system-tokens";
import type { LicenseStatusResource } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import { useSpaceAwareNavigation } from "../Navigation/SpaceAwareNavigation/useSpaceAwareNavigation";
export function AddLicenseBanner({ licenseStatus }: {
    licenseStatus: LicenseStatusResource | null;
}) {
    const navigation = useSpaceAwareNavigation();
    const isInitialisationLicense = licenseStatus?.IsInitialisationLicense;
    if (!isInitialisationLicense) {
        return null;
    }
    const onBannerClicked = () => {
        navigation.navigate(links.licensePage.generateUrl());
    };
    return (<div className={cx(styles.bannerContainer)} onClick={onBannerClicked}>
            <InfoCircleIcon size={20}/>
            <div className={styles.viewLicense}>Add your license key to start using Octopus</div>
        </div>);
}
const styles = {
    bannerContainer: css({
        minHeight: "2.25rem",
        display: "flex",
        flexWrap: "wrap",
        padding: `${space[8]} ${space[12]}`,
        justifyContent: "center",
        gap: space[6],
        borderRadius: borderRadius["small"],
        cursor: "pointer",
        fontSize: fontSize["medium"],
        "& b": {
            fontWeight: fontWeight["700"],
        },
        backgroundColor: themeTokens.color.callout.background.info.default,
        "& svg": {
            fill: themeTokens.color.callout.icon.info,
        },
        "&:hover": {
            backgroundColor: themeTokens.color.callout.background.info.hover,
        },
        "&:active": {
            backgroundColor: themeTokens.color.callout.background.info.pressed,
        },
    }),
    viewLicense: css({
        color: themeTokens.color.text.primary,
        fontSize: fontSize["medium"],
        fontWeight: fontWeight["400"],
    }),
};
